import { render, staticRenderFns } from "./TeamModal.vue?vue&type=template&id=8f76b800&"
import script from "./TeamModal.vue?vue&type=script&lang=js&"
export * from "./TeamModal.vue?vue&type=script&lang=js&"
import style0 from "./TeamModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports